import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Switch, Redirect } from 'react-router-dom';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import { Route } from '../../components/AppRoute';
import NotFound from '../../components/NotFound';
import { RaffleAuth, SelectSneakersV1, SelectSneakersV2 } from './RaffleChild/RaffleSelectSneakers';

class RaffleCommonGround extends React.Component {
  render() {
    return (
      <Container fluid className="main-container raffle-container">
        <Switch>
          {this.props.routes.map((route, index) =><Route key={index} {...route} />)}
          <Redirect to="/404"/>
        </Switch>
      </Container>
    )
  }
}

export default RaffleCommonGround;
